import { i18n } from "src/boot/i18n";

export function getRandomTip(optional = false) {
  if (optional && Math.random() < 0.5) {
    return ''
  }
  return i18n.t[Math.floor(Math.random() * (Math.floor(6) + 1))]
}

export function getRandomConfirmationTip() {
  return i18n.t[Math.floor(Math.random() * (Math.floor(2) + 1))]
}
